export default __webpack_public_path__ + "static/media/kl-06.a29e032b.png";